import type { AuditEntry } from '@titan/shared';
import { EmptyState, ListContainer, ListHeader, ListRow, PrimaryCell, RowMeta, RowText } from '../../ui/index.js';

function when(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

/** Spec 07 "Administration activity". Keyed by tenant, kept for 400 days. */
export function AuditList({ audit, title = 'Administration activity' }: { audit: AuditEntry[]; title?: string }) {
  return (
    <ListContainer>
      <ListHeader title={title} description="Every entitlement and access change on this tenant, kept for 400 days" />
      {audit.length === 0 && <EmptyState>No changes recorded yet. Entitlement, seat and access changes appear here as they happen.</EmptyState>}
      {audit.map((a) => (
        <ListRow key={a.id}>
          <PrimaryCell>
            <RowText>{a.summary}</RowText>
            <RowMeta>
              {when(a.at)} · {a.actorEmail}
              {a.onBehalfOf ? ` · on behalf of DinoCloud (${a.onBehalfOf})` : ''}
            </RowMeta>
          </PrimaryCell>
        </ListRow>
      ))}
    </ListContainer>
  );
}
